( function () {
	'use strict';

	function LeftNav ( $route, routehelper, $rootScope, groupIndexService, authService, layoutFactory ) {
		var self   = this;
		var routes = routehelper.getRoutes();

		function getNavRoutes () {
			self.navRoutes = routes.filter( function ( r ) {
				return r.settings && r.settings.nav;
			} ).sort( function ( r1, r2 ) {
				return r1.settings.nav - r2.settings.nav;
			} );
		}

		function setIndex ( index ) {
			groupIndexService.setIndex( index );
		}

		function attachGroups () {
			$rootScope.$on( 'obs:get:groups', function ( event, groupsData, onTemplate, addTemplateGroup, isLoaded ) {
				$rootScope.$on( 'obs:get:groups:noparam', function ( check ) {
					self.quickAccessCheck       = check;
					$rootScope.obsGroupsData    = groupsData;
					self.onTemplate             = onTemplate;
					self.isLoaded               = isLoaded;
					$rootScope.addTemplateGroup = addTemplateGroup;
				} );

				$rootScope.$broadcast( 'obs:get:groups:noparam' );
			} );
		}

		function inValidResult () {
			return false;
		}

		function isVisible () {
			return ( self.quickAccessCheck && self.onTemplate && ( self.isLoaded || inValidResult )() ) || !self.onTemplate;
		}

		function activate () {
			getNavRoutes();
			attachGroups();
			self.mobileDevice = layoutFactory.checkPlatform();
		}

		function isCurrent ( route ) {
			if ( !route.title || !$route.current || !$route.current.title || !$route.current.state  ) {
				return '';
			}

			var classDef = '';
			var menuName = route.state;

			if ( $route.current.state === menuName ) {
				classDef = 'active';
			}

			return classDef;
		}

		self.isCurrent      = isCurrent;
		self.setIndex       = setIndex;
		self.isVisible      = isVisible;
		self.isViewOnlyMode = authService.isViewOnlyMode();

		activate();
	}

	angular
		.module( 'app.layout' )
		.controller( 'LeftNav', LeftNav );

	LeftNav.$inject = [ '$route', 'routehelper', '$rootScope', 'groupIndexService', 'authService', 'layoutFactory' ];
} )( );
